<div
  class="v4-layout-dropdown !p-0 !rounded-[4px]"
  [ngClass]="{
    'w-[220px]': isInternational,
    'w-[150px]': !isInternational
  }"
>
  <div class="flex pt-[4px] w-full">
    <div class="w-1/2 h-[224px] overflow-y-hidden hover:overflow-y-auto overflow-x-hidden" #hourListElement>
      <div
        *ngFor="let hour of optionsOfHour"
        class="opt-item leading-[28px] pl-[14px] cursor-pointer whitespace-nowrap"
        [ngClass]="{ 'bg-[#f0f9ff]': hour.value === hourStr }"
        (click)="onSelectHour(hour)"
      >
        {{ hour.label }}
      </div>
    </div>
    <div
      class="w-1/2 h-[224px] overflow-y-hidden hover:overflow-y-auto border-solid border-l border-[#f0f0f0]"
      #minuteListElement
    >
      <div
        *ngFor="let minute of optionsOfMinute"
        class="opt-item leading-[28px] pl-[14px] cursor-pointer whitespace-nowrap"
        [ngClass]="{ 'bg-[#f0f9ff]': minute.value === minuteStr }"
        (click)="onSelectMinute(minute)"
      >
        {{ minute.label }}
      </div>
    </div>
  </div>
  <div class="flex flex-row items-center justify-end px-[12px] h-[40px] border-t border-solid border-[#f0f0f0]">
    <a nz-button nzSize="small" nzType="link" (click)="onClickCancel()">
      {{ 'word.cancel' | translate }}
    </a>
    <a class="ml-2" nzSize="small" nz-button nzType="link" (click)="onClickConfirm()">
      {{ 'word.save' | translate }}
    </a>
  </div>
</div>
